import { render, staticRenderFns } from "./CreateErrorDialog.vue?vue&type=template&id=4ff01c28"
import script from "./CreateErrorDialog.vue?vue&type=script&lang=ts"
export * from "./CreateErrorDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports